import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { IAdults } from 'app/models/Placement/PlacementMods';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditPreferenceAdultRows,
  selectPreferenceAdultNameError,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { getDisplayValue } from '../utils';

interface GridCellProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const AdultNameCell = (cellParams: GridRenderEditCellParams) => {
  return (
    <>
      <AdultName cellParams={cellParams} />
    </>
  );
};

//*-- START -- Helper Functions

export const findRow = (editPreferenceAdultRowsRequests, RowId) => {
  return editPreferenceAdultRowsRequests?.find(row => row.id === RowId);
};
export const findIndex = (editPreferenceAdultRowsRequests, RowId) => {
  return editPreferenceAdultRowsRequests?.findIndex(row => row.id === RowId);
};
//*-- END -- Helper Functions

const AdultName = React.memo(function AdultName(cellParams: GridCellProps) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const editPreferenceAdultRowsRequests = useSelector(selectEditPreferenceAdultRows);
  const preferenceAdultNameError = useSelector(selectPreferenceAdultNameError);

  const RowId = cellParams?.cellParams?.id;
  const rowData = getDisplayValue(RowId, editPreferenceAdultRowsRequests);
  const name = rowData?.name;
  const [adultName, setAdultName] = useState(name === '--' ? null : name);

  const setNameForAdultGridEdit = data => {
    let newRows = editPreferenceAdultRowsRequests.slice(0);
    let adultGridEditRow = findRow(editPreferenceAdultRowsRequests, RowId);

    let updatedName = {} as IAdults;
    updatedName = {
      ...adultGridEditRow,
      name: data ? data.trim() : '',
    };
    let editNameIndex = findIndex(editPreferenceAdultRowsRequests, RowId);
    newRows[editNameIndex] = updatedName;
    dispatch(placementModsAction.setEditAdultRows(newRows));
  };
  //UPDATE THE ERROR
  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = preferenceAdultNameError?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = preferenceAdultNameError?.length > 0 ? preferenceAdultNameError.slice(0) : [];
        const valueObj = { name: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setPreferenceAdultNameError(arr));
      } else {
        const arr = preferenceAdultNameError?.slice(0);
        let currentObj = arr.find(v => v.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, name: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(v => v.id === cellParams?.cellParams?.id);
        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setPreferenceAdultNameError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <>
      <Controller
        name={`adultGrid${RowId}.name`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            required={true}
            variant="outlined"
            size={'small'}
            sx={{
              width: '274px',
            }}
            value={adultName}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setNameForAdultGridEdit(e.target.value);
              onChange(e.target.value);
            }}
            onChange={e => {
              if (e.target.value) {
                setAdultName(e.target.value);
                onChange(e.target.value);
              } else {
                setAdultName('');
              }
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
